export const I18N = {
  en: {
    careers_title: 'Join the Elite Roofing Team',
    careers_subhead: "We're hiring hardworking, reliable people who want to grow with us. No license required — just integrity, hustle, and a willingness to learn. Bilingual English/Spanish encouraged.",
    why_work_here: 'Why Work Here',
    why_1_title: 'Paid weekly',
    why_1_body: 'Competitive pay with reliable weekly paychecks.',
    why_2_title: 'Year-round work',
    why_2_body: 'Central Florida’s busy season is every season.',
    why_3_title: 'Real growth path',
    why_3_body: 'Helper → crew → foreman → project manager.',
    why_4_title: 'Family-feel team',
    why_4_body: 'We treat our team like family, not labor.',
    open_positions: 'Open Positions',
    apply_for_role: 'Apply for this role',
    requirements_title: 'Requirements',
    req_1: 'No contractor license required — we are licensed (CGC032777). You work under our license.',
    req_2: 'Must be 18+.',
    req_3: 'Valid driver’s license preferred but not required for all roles.',
    req_4: 'Comfortable working at heights for roofing positions.',
    req_5: 'OSHA-10 a plus — we’ll pay to send qualified hires through it.',
    req_6: 'Bilingual English/Spanish is a major plus.',
    apply_now: 'Apply Now',
    section_personal: 'Personal Info',
    section_position: 'Position',
    section_qualifications: 'Qualifications',
    section_about: 'About You',
    section_consent: 'Consent',
    full_name: 'Full Name',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    city: 'City',
    state: 'State',
    zip: 'ZIP',
    dob: 'Date of Birth',
    position: 'Position Applying For',
    years_experience: 'Years of Relevant Experience',
    currently_employed: 'Currently Employed?',
    start_date: 'Available Start Date',
    drivers_license: 'Valid driver’s license?',
    transportation: 'Own transportation to job sites?',
    heights: 'Comfortable working at heights?',
    languages: 'Languages spoken fluently',
    certifications: 'OSHA-10 or other certifications (optional)',
    work_auth: 'Legally authorized to work in U.S.?',
    why_join: 'Why join Elite Roofing? (optional, max 500 chars)',
    source: 'How did you hear about us?',
    resume: 'Resume Upload (optional)',
    consent_text: 'I confirm the information above is accurate and authorize Elite Roofing & Construction to contact me about this position.',
    submit_application: 'Submit Application',
    yes: 'Yes',
    no: 'No',
    select_one: 'Select one',
    success_title: 'Application received!',
    success_body: 'We review every application personally. If your background is a fit, we’ll reach out within 3 business days.',
  },
  es: {
    careers_title: 'Únete al equipo de Elite Roofing',
    careers_subhead: 'Estamos contratando personas trabajadoras y confiables que quieran crecer con nosotros. No se requiere licencia — solo integridad, esfuerzo y ganas de aprender. Se valora ser bilingüe inglés/español.',
    why_work_here: '¿Por qué trabajar con nosotros?',
    why_1_title: 'Pago semanal',
    why_1_body: 'Pago competitivo y consistente cada semana.',
    why_2_title: 'Trabajo todo el año',
    why_2_body: 'En Florida Central, todo el año hay trabajo.',
    why_3_title: 'Crecimiento real',
    why_3_body: 'Ayudante → cuadrilla → capataz → gerente de proyectos.',
    why_4_title: 'Equipo tipo familia',
    why_4_body: 'Tratamos a nuestro equipo como familia.',
    open_positions: 'Vacantes',
    apply_for_role: 'Solicitar este puesto',
    requirements_title: 'Requisitos',
    req_1: 'No se requiere licencia de contratista — estamos licenciados (CGC032777). Usted trabaja bajo nuestra licencia.',
    req_2: 'Debe tener 18 años o más.',
    req_3: 'Licencia de conducir válida preferida pero no obligatoria para todos los puestos.',
    req_4: 'Comodidad trabajando en alturas para puestos de techado.',
    req_5: 'OSHA-10 es un plus — pagamos la certificación a los contratados calificados.',
    req_6: 'Ser bilingüe inglés/español es una gran ventaja.',
    apply_now: 'Solicitar Ahora',
    section_personal: 'Información personal',
    section_position: 'Puesto',
    section_qualifications: 'Calificaciones',
    section_about: 'Sobre usted',
    section_consent: 'Consentimiento',
    full_name: 'Nombre completo',
    phone: 'Teléfono',
    email: 'Correo electrónico',
    address: 'Dirección',
    city: 'Ciudad',
    state: 'Estado',
    zip: 'Código postal',
    dob: 'Fecha de nacimiento',
    position: 'Puesto al que aplica',
    years_experience: 'Años de experiencia relevante',
    currently_employed: '¿Trabajando actualmente?',
    start_date: 'Fecha disponible para comenzar',
    drivers_license: '¿Licencia de conducir válida?',
    transportation: '¿Transporte propio a los lugares de trabajo?',
    heights: '¿Cómodo trabajando en alturas?',
    languages: 'Idiomas que habla con fluidez',
    certifications: 'OSHA-10 u otras certificaciones (opcional)',
    work_auth: '¿Autorizado legalmente para trabajar en EE.UU.?',
    why_join: '¿Por qué desea unirse a Elite Roofing? (opcional, máx 500)',
    source: '¿Cómo se enteró de nosotros?',
    resume: 'Subir currículum (opcional)',
    consent_text: 'Confirmo que la información es correcta y autorizo a Elite Roofing & Construction a contactarme.',
    submit_application: 'Enviar solicitud',
    yes: 'Sí',
    no: 'No',
    select_one: 'Seleccione una opción',
    success_title: '¡Solicitud recibida!',
    success_body: 'Revisamos cada solicitud personalmente. Si su perfil encaja, le contactaremos en 3 días hábiles.',
  },
};
